import { useIsPresent } from 'framer-motion';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

// Custom scroll restoration to avoid jank during page transitions
export const ScrollRestore = () => {
  const isPresent = useIsPresent();
  const { asPath, beforePopState } = useRouter();
  const lastPath = useRef(asPath);

  useEffect(() => {
    // Opt out of native scroll restoration
    window.history.scrollRestoration = 'manual';
  }, []);

  // Prevent insta-scroll on browser back button
  useEffect(() => {
    beforePopState(state => {
      state.options.scroll = false;
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle scroll restoration
  useEffect(() => {
    if (!isPresent) return;
    /* Moving between books on the bookshelf is one page changing its own URL,
       and the bookshelf places the scroll itself. Scrolling to the top here
       threw the reader back to its first book on every open. */
    const shelf = /^\/bookshelf\//;
    const within = shelf.test(lastPath.current) && shelf.test(asPath);
    lastPath.current = asPath;
    if (within) return;
    const hash = asPath.split('#')[1];
    const targetElement = document.getElementById(hash);

    if (hash && targetElement) {
      // If there's a hash in the url and a matching element
      // id, scroll to and focus it
      window.scrollTo(0, targetElement.offsetTop);
      targetElement.focus({ preventScroll: true });
    } else {
      window.scrollTo(0, 0);
      document.body.focus({ preventScroll: true });
    }
  }, [asPath, isPresent]);
};
